// LIBRARIES
import {
  BORDER_RADIUS,
  COLORS,
  DEVICE_TYPE,
  MARGIN,
} from "constants/variables";
import styled from "styled-components";

export const ParentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  gap: ${MARGIN.max24};
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    flex-direction: column;
    padding-left: ${MARGIN.max24};
    padding-right: ${MARGIN.max24};
    gap: ${MARGIN.max12};
  }
`;

export const BigContainer = styled.div`
  width: 944px;
  min-width: 944px;
  height: 472px;
  border-radius: ${BORDER_RADIUS.radius24};
  background-color: ${COLORS.Crimson};
  padding: 46px ${MARGIN.max40} 55px ${MARGIN.max40};
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    width: 100%;
    min-width: 0px;
    height: auto;
    padding: ${MARGIN.max40} ${MARGIN.max24} ${MARGIN.max40} ${MARGIN.max24};
  }
`;

export const Title = styled.div`
  margin-bottom: ${MARGIN.max24};
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${MARGIN.max10};
`;

export const SmallContainer = styled.a`
  cursor: pointer;
  width: 224px;
  height: 224px;
  border-radius: ${BORDER_RADIUS.radius24};
  background-color: ${COLORS.Cultured};
  border: 1px solid ${COLORS.Cultured};
  display: flex;
  flex-direction: column;
  padding: ${MARGIN.max40} 30px;
  gap: ${MARGIN.fix16};
  justify-content: center;
  align-items: center;
  &:hover {
    background-color: ${COLORS.Background};
    transition: 0.3s ease-in;
  }
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    width: 100%;
    height: 165px;
    padding: ${MARGIN.max24};
    gap: ${MARGIN.max12};
    text-align: center;
  }
`;

export const SmallContainersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${MARGIN.max24};
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    flex-direction: row;
    width: 100%;
    gap: ${MARGIN.max12};
  }
`;

export const IconContainer = styled.img`
  width: 81.25px;
  height: 54.17px;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    width: 64px;
    height: 45px;
  }
`;

export const UnderlinedText = styled.span`
  text-decoration: underline;
  text-decoration-color: ${COLORS.Yellow};
`;
